import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProposeTransactionService {

  constructor(private http: HttpClient) { }

  /**
   * Gets aoccontract functions
   * @param address
   * @returns
   */
  getAOCContractFunctions(address: string) {
    return this.http.get(`${environment.API_BASE_URL}multisig/contracts/${address}/functions`)
  }

  /**
   * Gets distribution contract functions
   * @param address
   * @returns
   */
  getDistributionContractFunctions(address: string) {
    return this.http.get(`${environment.API_BASE_URL}multisig/contracts/${address}/functions`)
  }

  /**
   * Getsigners functions
   * @returns
   */
  getsignerFunctions() {
    return this.http.get(`${environment.API_BASE_URL}multisig/contracts/functions`);
  }

  /**
   * Gets monthly summary
   * @returns
   */
  getMonthlySummary() {
    return this.http.get(`${environment.CONTRIBUTION_BASE_URL}combined-monthly-summary`);
  }
}
